//components
import UserActions from "./userActionsStore";

const reducers = {
  UserActions,
};

export default reducers;
